module.exports = __webpack_public_path__ + "img/12.79da6439.jpg";